import type { HTMLAttributes } from 'react';
import activity from '../assets/icons/activity.svg?raw';
import bot from '../assets/icons/bot.svg?raw';
import check from '../assets/icons/check.svg?raw';
import chevron from '../assets/icons/chevron.svg?raw';
import close from '../assets/icons/close.svg?raw';
import copy from '../assets/icons/copy.svg?raw';
import key from '../assets/icons/key.svg?raw';
import logout from '../assets/icons/logout.svg?raw';
import play from '../assets/icons/play.svg?raw';
import plus from '../assets/icons/plus.svg?raw';
import refresh from '../assets/icons/refresh.svg?raw';
import search from '../assets/icons/search.svg?raw';
import stop from '../assets/icons/stop.svg?raw';
import trash from '../assets/icons/trash.svg?raw';
import warning from '../assets/icons/warning.svg?raw';
import grid from '../assets/icons/grid.svg?raw';
import table from '../assets/icons/table.svg?raw';

type IconProps = HTMLAttributes<HTMLSpanElement> & { title?: string };

function fromRaw(raw: string, props: IconProps): JSX.Element {
  const { title, className = '', ...rest } = props;
  return (
    <span
      className={`tbm-icon ${className}`.trim()}
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      {...rest}
      dangerouslySetInnerHTML={{ __html: raw }}
    />
  );
}

export const Icons = {
  chevron: (p: IconProps) => fromRaw(chevron, p),
  copy: (p: IconProps) => fromRaw(copy, p),
  check: (p: IconProps) => fromRaw(check, p),
  close: (p: IconProps) => fromRaw(close, p),
  search: (p: IconProps) => fromRaw(search, p),
  plus: (p: IconProps) => fromRaw(plus, p),
  trash: (p: IconProps) => fromRaw(trash, p),
  play: (p: IconProps) => fromRaw(play, p),
  stop: (p: IconProps) => fromRaw(stop, p),
  refresh: (p: IconProps) => fromRaw(refresh, p),
  warning: (p: IconProps) => fromRaw(warning, p),
  key: (p: IconProps) => fromRaw(key, p),
  bot: (p: IconProps) => fromRaw(bot, p),
  logout: (p: IconProps) => fromRaw(logout, p),
  activity: (p: IconProps) => fromRaw(activity, p),
  grid: (p: IconProps) => fromRaw(grid, p),
  table: (p: IconProps) => fromRaw(table, p),
};
